module.exports = __webpack_public_path__ + "cdcd43e05599109ef5f98bab9e93144a.svg";